<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Customers" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                            </template>
                            <el-option
                              v-for="(item, index) in search_by_dropdown['selectedTableTab']"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_customer"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>

    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
    />



    <!-- Abatement confirmation: show session counts and choose Calculate remaining vs Reset abatement -->
    <el-dialog
      class="public-style"
      v-model="abatementConfirmVisible"
      title="Confirm Abatement calculation"
      width="600"
      align-left
      @close="abatementConfirmData = null; abatementConfirmTableRows = []; abatementConfirmMode = 'remain'"
    >
      <div v-if="abatementConfirmData">
        <div class="custom-table-design">
        <el-table
          :data="abatementConfirmTableRows"
          class="my-2 data-table"
          stripe
        >
          <el-table-column prop="label" label="" min-width="200" />
          <el-table-column prop="value" label="" min-width="260">
            <template #default="scope">
              <span v-if="scope.row.label === 'Mode'">
                <el-radio-group v-model="abatementConfirmMode" class="abatement-mode-switch">
                  <el-radio-button label="remain">Calculate remain</el-radio-button>
                  <el-radio-button label="reset">Reset All</el-radio-button>
                </el-radio-group>
              </span>
              <span v-else-if="scope.row.label === 'Confirm'">
                {{ abatementConfirmMode === 'remain'
                  ? 'Do you want to recalculate the abatement for ' + (abatementConfirmData?.sessionsWithoutAbatement ?? '—') + ' sessions without abatement?'
                  : 'Do you want to recalculate the abatement for all ' + (abatementConfirmData?.totalSessions ?? '—') + ' sessions?' }}
              </span>
              <span v-else>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="medium"
            class="me-primary-light"
            color="#234B49"
            @click="runAbatementOption(abatementConfirmMode === 'reset')"
          >
            <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
          </el-button>
          <el-button
            size="medium"
            class="me-primary"
            color="#ddf0ac"
            @click="abatementConfirmVisible = false"
          >
            <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
          </el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
// import Filter from "./filter.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import { convertToTitleCase } from "../dashboard/common/common-tools";
import { exportToExcel } from "../dashboard/common/exportExcel";
import { addTaskIdtoSessionStorage, createCeleryTaskPoller } from "../dashboard/common/pollingCeleryTask";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "customers",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Customers",
          disabled: false,
          href: "/customers",
          active: true,
        },
      ],

      show: true,
      customerDataList: [],
      search: "",

      search_by_dropdown:
        {
          selectedTableTab: [
            'full_name',
            'phone',
            'country',
            'timezone_convert',
          ],
        },

      selectedSearchBy: 'full_name',

      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_delete_modal: false,
      data_delete_modal: null,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,

      abatementConfirmVisible: false,
      abatementConfirmData: null,
      abatementConfirmTableRows: [],
      abatementConfirmMode: "remain",
    };
  },
  watch: {},
  computed: {
    filter_customer() {
      // let list = this.customerDataList.filter((item) => {
      //   return (
      //     (item.full_name === undefined ? "" : item.full_name)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.phone === undefined ? "" : item.phone)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.effective_from === undefined ? "" : item.effective_from)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.country === undefined ? "" : item.country)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1
      //   );
      // });
      // // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.total_items = list.length;
      // let paginated = this.paginate(list, this.page_size, this.current_page);
      // return paginated;
      return this.customerDataList;
    },

  },
  mounted() {
    this.fetchCustomerData(this.current_page);
  },
  methods: {

    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },

    fetchCustomerData(page) {
      UserService.getCustomers(this.selectedSearchBy, this.search, page, this.perPageCount)
        .then(
          (response) => {
            this.customerDataList = response.data.customers;
            this.total_items = response.data.total_record;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    async DeleteCustomer(user, index) {
      try {
        let deleteCustomerAllDataResponse = await UserService.deleteCustomerAllData(user.id);
        if (deleteCustomerAllDataResponse.status == 200 || deleteCustomerAllDataResponse.data.code == 1000) {
          console.log("Delete customer data success");
          let deleteCustomerResponse = await UserService.deleteCustomer(user.id);
          if (deleteCustomerResponse.status == 200 || deleteCustomerResponse.data.code == 1000) {
            console.log("Delete customer success");
            this.customerDataList.splice(index, 1);
          } else {
            console.log("Delete customer failed");
            useToast().error(" The operation has occurred an error.", {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 2000,
            });
          }
        } else {
          console.log("Delete customer all data failed");
          useToast().error(" The operation has occurred an error.", {
            icon: "fa fa-times",
            position: "bottom-right",
            timeout: 2000,
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
        if (error.response && error.response.status == 401) {
          this.$router.push({
            path: "/",
          });
        }
      } finally {
        this.loading = false;
      }
    },

    DeleteAllData(user) {
      console.log(user);
      UserService.deleteCustomerAllData(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            useToast().success(
              " All data for this user has been deleted successfully ",
              {
                icon: "fa fa-check",
                position: "bottom-right",
                timeout: 2000,
              }
            );
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            } else {
              useToast().error(" The operation has occurred an error.", {
                icon: "fa fa-times",
                position: "bottom-right",
                timeout: 2000,
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    RunAbatement(user) {
      this.loading = true;
      const findCurrentMP = (list) => {
        const current = (list || []).filter((mp) => mp.status === "current");
        if (current.length > 0) {
          return current.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
        }
        const underAudit = (list || []).filter((mp) => mp.status === "under_audit");
        if (underAudit.length > 0) {
          return underAudit.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
        }
        return list?.[0] || null;
      };
      UserService.getMonitoringPeriods(null, "", 1, 50, true)
        .then((response) => {
          const list = response?.data?.monitoring_periods || [];
          const currentMP = findCurrentMP(list);
          const start_date = currentMP ? (currentMP.start_date || "").replace("T", " ") : null;
          const end_date = currentMP ? (currentMP.end_date || "").replace("T", " ") : null;
          const request = {
            customer_id: user.id,
            start_date,
            end_date,
            mp_id: currentMP?.id ?? null,
          };
          return UserService.getSessionsForAbatementCalculation(request).then((res) => ({ res, request }));
        })
        .then(({ res: response, request }) => {
          const raw = response?.data?.data ?? response?.data ?? response;
          const list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
          const row = list[0] || {};
          const customerFullName = row?.full_name?.full_name ?? row?.customer_full_name ?? row?.customer_name ?? user?.full_name ?? "";
          const totalSessions = row?.total_sessions ?? row?.total_count ?? "—";
          const sessionsWithAbatement = row?.sessions_with_abatement ?? row?.with_abatement ?? "—";
          const sessionsWithoutAbatement = row?.sessions_without_abatement ?? row?.without_abatement ?? "—";
          const startDate = request.start_date ? String(request.start_date) : "All";
          const endDate = request.end_date ? String(request.end_date) : "All";
          this.abatementConfirmData = {
            customer_id: user.id,
            customerFullName,
            startDate,
            endDate,
            totalSessions,
            sessionsWithAbatement,
            sessionsWithoutAbatement,
            request,
          };
          this.abatementConfirmTableRows = [
            { label: "Customer full name", value: customerFullName },
            { label: "Start date", value: startDate },
            { label: "End date", value: endDate },
            { label: "Total sessions", value: String(totalSessions) },
            { label: "Sessions with abatement", value: String(sessionsWithAbatement) },
            { label: "Sessions without abatement", value: String(sessionsWithoutAbatement) },
            { label: "Mode", value: "" },
            { label: "Confirm", value: "" },
          ];
          this.abatementConfirmMode = "remain";
          this.abatementConfirmVisible = true;
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            this.$router.push({ path: "/" });
          } else {
            useToast().error(err?.message || "The operation has occurred an error.", {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 2000,
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    runAbatementOption(resetAbatement) {
      const data = this.abatementConfirmData;
      if (!data) return;
      this.abatementConfirmVisible = false;
      const filter = {
        customer_id: data.customer_id,
        reset_abatement: resetAbatement,
        mp_id: data.request.mp_id,
      };
      if (resetAbatement && data.request) {
        filter.mp_id = data.request.mp_id;
      }
      UserService.AbatementCalculate(filter)
        .then((response) => {
          useToast().success(
            "The abatement calculation job has been submitted. Please allow a few minutes for the portal to update.",
            {
              icon: "fa fa-check",
              position: "bottom-right",
              timeout: 2000,
            }
          );
          const task_id = response.data.task_id;
          addTaskIdtoSessionStorage("abatement_calculate", task_id, "PENDING", "message", {
            success_message: "The abatement calculation job is successfully completed.",
            error_message: "The abatement calculation job is failed. Please try again.",
          });
          const poller = createCeleryTaskPoller(task_id, 30000, "abatement_calculate");
          poller.startPolling();
          this.abatementConfirmData = null;
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            this.$router.push({ path: "/" });
          } else {
            useToast().error(err?.message || "The operation has occurred an error.", {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 2000,
            });
          }
        });
    },
    escapeHtml(str) {
      const div = document.createElement("div");
      div.textContent = str;
      return div.innerHTML;
    },

    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    close_delete_modal() {
      this.show_delete_modal = false;
    },

    confirm_modal(event) {
      if (this.customerDataList.length == this.current_row_index)
        this.customerDataList.push(event);
      else this.customerDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async handleExportFile() {
      if (this.filter_customer.length > 0) {

        const dataList = this.filter_customer;
        const skipKeys = ["id", "timezone_convert"]; // Keys to skip
        const fileName = "Customers.xlsx"; // File name
        const newWorksheetName = "Customer List"; // Worksheet name
        const title = "Customer List"; // Title for the Excel file

        try {


        await exportToExcel({
          dataList,
          skipKeys,
          fileName,
          newWorksheetName,
          title,
        });
      } catch (error) {
        console.log("error when export excel", error.message);

      }
      }
    },

    // handleExportFile() {
    //   if (this.filter_customer.length > 0) {
    //     const myHeader = [
    //       "full_name",
    //       "phone",
    //       "effective_from",
    //       "country",
    //       "has_user",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_customer, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "CustomerList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
      this.fetchCustomerData(this.current_page);
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchCustomerData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      } else if (event.kind == "setting") {
        this.deleteAllDataRow(event.data);
      } else if (event.kind == "abatement") {
        this.RunAbatement(event.data);
      }
    },

    handleReload() {
      this.fetchCustomerData(this.current_page);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        private_fleet: false,
        is_active: true,
        customer_id: null,
        id: 0,
      };
      this.current_row_index = this.customerDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    deleteRow(event, index) {
      // console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this customer and all data?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteCustomer(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },

    deleteAllDataRow(event) {
      console.log(event);
      ElMessageBox.confirm(
        "Are you sure to delete all data of this customer?",
        "info",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "Confirm Delete",
        }
      )
        .then(() => {
          this.DeleteAllData(event);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
